module.exports = __webpack_public_path__ + "img/bj26.f9c5c944.png";